/** AUTO GENERATED FROM "node ./src/utils/build-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg
        width="79.12"
        height="94.35"
        viewBox="0 0 79.12 94.35"
        fill="currentColor"
        className={classNames('nmx-icon', className)}
        ref={svgRef}
        {...otherProps}>
        <path
          fill="#fff"
          d="M40.81 63.97v11.75h-2.5V63.97Z"
          className="icon-fill icon-base"/>
        <path
          fill="#fff"
          d="M39.56 43.79a1.26 1.26 0 0 1 1.25 1.12V64a1.24 1.24 0 0 1-1.28 1.21 1.26 1.26 0 0 1-1.21-1.09V45a1.24 1.24 0 0 1 1.24-1.21Z"
          className="icon-fill icon-base"/>
        <path
          fill="#fff"
          d="M40.81 63.97v11.75h-2.5V63.97ZM32.75 63.97v11.75h-2.5V63.97ZM39.57 0a8.59 8.59 0 1 0 8.59 8.59A8.59 8.59 0 0 0 39.57 0Zm0 2.5a6.09 6.09 0 1 1-6.09 6.09 6.08 6.08 0 0 1 6.09-6.09Z"
          className="icon-fill icon-base"/>
        <path
          fill="none"
          d="M39.56 63.97v11.76"/>
        <path
          fill="#fff"
          d="M40.81 63.97v11.75h-2.5V63.97Z"
          className="icon-fill icon-base"/>
        <path
          fill="none"
          d="M39.56 45.04v18.93"/>
        <path
          fill="#fff"
          d="M39.56 43.79a1.26 1.26 0 0 1 1.25 1.12V64a1.24 1.24 0 0 1-1.28 1.21 1.26 1.26 0 0 1-1.21-1.09V45a1.24 1.24 0 0 1 1.24-1.21Z"
          className="icon-fill icon-base"/>
        <path
          fill="none"
          d="M39.56 63.97v11.76"/>
        <path
          fill="#fff"
          d="M40.81 63.97v11.75h-2.5V63.97Z"
          className="icon-fill icon-base"/>
        <path
          fill="none"
          d="M31.48 63.97v11.76"/>
        <path
          fill="#fff"
          d="M32.75 63.97v11.75h-2.5V63.97Z"
          className="icon-fill icon-base"/>
        <path
          fill="#fff"
          d="M64.88 10.11a4.28 4.28 0 0 1 2.75 7.57l-.19.16L48.9 30.67v33.35a1.24 1.24 0 0 1-1.12 1.23h-.13a1.25 1.25 0 0 1-1.25-1.14V30a1.29 1.29 0 0 1 .43-1l.11-.09 19-13.15a1.79 1.79 0 0 0-1.09-3.21 1.92 1.92 0 0 0-.74.15l-.17.09-15.7 9a1.09 1.09 0 0 1-.49.16H31.48a1.28 1.28 0 0 1-.51-.09l-.11-.07-15.71-9a1.76 1.76 0 0 0-.9-.24 1.79 1.79 0 0 0-1.79 1.79 1.82 1.82 0 0 0 .54 1.34l.12.09L32.19 29a1.21 1.21 0 0 1 .53.89V64a1.24 1.24 0 0 1-1.27 1.22 1.26 1.26 0 0 1-1.22-1.1V30.67l-18.6-12.86A4.24 4.24 0 0 1 10 14.66v-.25a4.3 4.3 0 0 1 4.29-4.29 4.44 4.44 0 0 1 1.93.45l.22.12 15.41 8.86h15.5l15.4-8.88a4.26 4.26 0 0 1 1.9-.58Z"
          className="icon-fill icon-base"/>
        <path
          fill="none"
          d="M47.65 63.97v11.76"/><path
          fill="#fff"
          d="M48.9 63.97v11.75h-2.5V63.97Z"
          className="icon-fill icon-base"/>
        <path
          fill="#ffb81c"
          d="M26.75 81v2.5H2.5v10.84H0V82.25A1.23 1.23 0 0 1 1.12 81ZM77.88 86.14a1.24 1.24 0 0 1 1.24 1.12v7.07h-2.5v-5.66H52.33v-2.5Z"
          className="icon-fill icon-accent"/>
        <path
          fill="#ffb81c"
          d="M52.33 74.08a1.27 1.27 0 0 1 1.25 1.12v19.13h-2.5V76.59H28v17.74h-2.5v-19a1.25 1.25 0 0 1 1.12-1.25Z"
          className="icon-fill icon-accent"/>
      </svg>

    );
  }
}

Icon.displayName = 'OnePersonOnChampionshipPodiumFirstPlaceIcon';

export default Icon;
